import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-warning',
  imports: [],
  templateUrl: './warning.component.html',
  styleUrl: './warning.component.scss'
})
export class WarningComponent {
  message = input.required<string>();
  close = input<boolean>();
  onClose = output<void>();

  closeToast() {
    this.onClose.emit();
  }
}

